import { HeroImage } from "@/components/auth/hero-image";
import { OnboardingPage } from "@/components/auth/onboarding-page";
import { Link, LinkButton } from "@/components/core/tanstack-link";
import { AddNewIntegration } from "@/components/settings/finance-integrations";
import { queryClient } from "@/helpers/tanstack-client";
import { PricingFeature, getAccount, getGetAccountQueryKey } from "@/models/backend";
import { Breadcrumbs, Stack, Typography } from "@mui/material";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/onboarding/invoices")({
  component: RouteComponent,
  loader: async () => {
    const data = await queryClient.fetchQuery({
      queryFn: getAccount,
      queryKey: getGetAccountQueryKey(),
    });
    if (data) {
      throw redirect({ to: "/onboarding/email" });
    }
  },
});

function RouteComponent() {
  return (
    <OnboardingPage
      page={
        <Stack spacing={6}>
          <Breadcrumbs separator=">">
            <Link to="/onboarding/about-you">About you</Link>
            <Typography>Invoices</Typography>
            <Link to="/onboarding/email">Email</Link>
          </Breadcrumbs>
          <Stack spacing={1}>
            <Typography variant="h3">Find your invoices</Typography>
            <Typography variant="body1" color="text.secondary">
              Trove syncs with the software where you invoice customers.
            </Typography>
          </Stack>
          <AddNewIntegration features={[PricingFeature.premium_integrations]} />
          <LinkButton to="/onboarding/email" sx={{ mr: "auto" }} variant="outlined">
            Skip
          </LinkButton>
        </Stack>
      }
      hero={
        <HeroImage
          url="/assets/onboarding-3.svg"
          copy="Get visibility over who owes you what"
          imageMaxWidth="864px"
        />
      }
    />
  );
}
